import React, { ComponentProps, FunctionComponent } from "react";

const CompetitionRibbonIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 35",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 11.7817C0 5.38454 5.18728 0.197754 11.584 0.197754C17.9807 0.197754 23.168 5.38503 23.168 11.7817C23.168 18.1784 17.9807 23.3657 11.584 23.3657C5.18728 23.3657 0 18.1784 0 11.7817Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.5845 25.1005C9.54304 25.1005 7.61489 24.6819 5.79248 24.0347V34.8023L11.5845 29.0103L17.3765 34.8023V24.0347C15.5559 24.6819 13.6258 25.1005 11.5845 25.1005Z",
    })
  );
};

const ForwardRef = React.forwardRef(CompetitionRibbonIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
